import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Resets window scroll to the top on every route change (P3.5).
 * Distinct from ScrollToTop, which is the floating button.
 */
const RouteScrollTop = (): null => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export default RouteScrollTop
